<template>
	<div class="timeline">
		<div v-if="match.sport === 'soccer'">
			<div class="timeline_head" v-if="penalty.length">Серия пенальти</div>
			<timeline-base :incidents="penalty" v-if="penalty.length"></timeline-base>
			<div class="timeline_head" v-if="time3.length">Овертайм</div>
			<timeline-base :incidents="time3" v-if="time3.length"></timeline-base>
			<div class="timeline_head" v-if="time2.length">2-й тайм</div>
			<timeline-base :incidents="time2" v-if="time2.length"></timeline-base>
			<div class="timeline_head" v-if="time1.length">1-й тайм</div>
			<timeline-base :incidents="time1" v-if="time1.length"></timeline-base>
		</div>
		
		<div v-if="match.sport === 'hockey'">
			<div class="timeline_head" v-if="time4.length">Овертайм</div>
			<timeline-hockey :incidents="time4" v-if="time4.length"></timeline-hockey>
			<div class="timeline_head" v-if="time3.length">3-й период</div>
			<timeline-hockey :incidents="time3" v-if="time3.length"></timeline-hockey>
			<div class="timeline_head" v-if="time2.length">2-й период</div>
			<timeline-hockey :incidents="time2" v-if="time2.length"></timeline-hockey>
			<div class="timeline_head" v-if="time1.length">1-й период</div>
			<timeline-hockey :incidents="time1" v-if="time1.length"></timeline-hockey>
		</div>
		
		<div v-if="match.sport === 'basketball'">
			<timeline-basketball :match="match"></timeline-basketball>
		</div>
		
		<div v-if="match.sport === 'tennis'">
			<timeline-tennis :match="match"></timeline-tennis>
		</div>
		<div v-if="match.sport === 'volleyball'">
			<timeline-volleyball :match="match"></timeline-volleyball>
		</div>
		<div v-if="match.sport === 'box'">
			<timeline-box :match="match"></timeline-box>
		</div>
		<div v-if="match.sport === 'mma'">
			<timeline-mma :match="match"></timeline-mma>
		</div>
		<div v-if="match.sport === 'biathlon'">
			<timeline-biathlon :match="match"></timeline-biathlon>
		</div>
	</div>
</template>

<script>
	import TimelineBase from "./TimelineBase";
	import TimelineHockey from "./TimelineHockey";
	import TimelineBasketball from "./TimelineBasketball";
	import TimelineTennis from "./TimelineTennis";
	import TimelineVolleyball from "./TimelineVolleyball";
	import TimelineBox from "./TimelineBox";
	import TimelineMma from "./TimelineMma";
	import TimelineBiathlon from "./TimelineBiathlon";
	
	export default {
		components: {
			TimelineBase,
			TimelineHockey,
			TimelineBasketball,
			TimelineTennis,
			TimelineVolleyball,
			TimelineMma,
			TimelineBox,
			TimelineBiathlon
		},
		
		props: ['data', 'match', 'sport'],
		
		computed: {
			incidents() {
				return this.data.filter((item) => {
					if (this.sport === 'soccer') {
						if (item.incedent_name === 'Penalty shootout scored' || item.incedent_name === 'Penalty shootout missed') {
							item.penalty = true;
						} else {
							if (item.time < 46) {
								item.period = 1;
							} else {
								item.period = item.time <= 90 ? 2 : 3;
							}
						}
					}
					if (item.incedent_type === 'goal') {
						var incedentNames = ['Regular goal', 'Own goal', 'Power Play goal', 'Missed penalty', 'Penalty', 'Extratime Goal', 'Extratime Penalty', 'Extratime own goal', 'Extratime penalty scored', 'Penalty shootout scored', 'Penalty shootout missed'];
						
						return item.incedent_type !== 'assist' && incedentNames.includes(item.incedent_name);
					}
					return item.incedent_type !== 'assist';
				});
			},
			time1() {
				return this.incidents.filter((item) => {
					return item.period === 1;
				}).reverse();
			},
			time2() {
				return this.incidents.filter((item) => {
					return item.period === 2;
				}).reverse();
			},
			time3() {
				return this.incidents.filter((item) => {
					return item.period === 3 && !item.penalty;
				}).reverse();
			},
			time4() {
				return this.incidents.filter((item) => {
					return item.period === 4;
				}).reverse();
			},
			penalty() {
				return this.incidents.filter((item) => {
					return item.penalty === true;
				}).reverse();
			},
		},
		
		created() {
			
		}
	}
</script>

<style scoped>

</style>